import { ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants } from '@festina/moneyin-general-types/moneyin/hooks/ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants'

export const useFetchMoneyInTenantsNoSuspense =
  ConfigurationTenantsService_tenantsServiceGetGetRegisteredTenants.useQuery
